export default {"src":"/_next/static/media/menu.c9ce66e0.svg","height":67,"width":68,"blurWidth":0,"blurHeight":0};